import React from "react";
import { Send } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useApp } from "@/context/AppContext";

export default function ChatInput({ value, onChange, onSend, busy }) {
  const { lang } = useApp();
  const onKey = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  };
  return (
    <div className="p-4 border-t border-[#D8CFBB] flex items-center gap-2 bg-[#FFFAF0]">
      <Input
        data-testid="chat-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKey}
        placeholder={lang === "it" ? "Scrivi un messaggio…" : "Type a message…"}
        className="bg-[#F5F0E6] border-[#D8CFBB] focus-visible:ring-[#C5A880]"
        maxLength={2000}
        disabled={busy}
      />
      <Button
        onClick={onSend}
        disabled={busy || !value.trim()}
        data-testid="chat-send"
        className="bg-[#C5A880] text-black hover:bg-[#d9bf94] rounded-full px-4"
      >
        <Send className="w-4 h-4" />
      </Button>
    </div>
  );
}
